import {Box, Button, Typography} from "@mui/material";
import {FormattingStyleOptions} from "../../sheets/conditionalFormatting/StyleOptions";
import React, {MouseEventHandler, useCallback, useContext} from "react";
import makeStyles from "@mui/styles/makeStyles";
import {IConstant} from "./Constant";
import {FirebaseContext} from "../../firebase/FirebaseProvider";
import {ConfirmContext} from "../../../utility/ConfirmProvider";
import {Constants} from "../../graph/StateTags";
import {StyleOptions} from "../../../utility/Style";

const useStyles = makeStyles((theme) => ({
    form: {
        display: "flex",
        flexDirection: "column",
        gap: 1,
        marginBottom: theme.spacing(1)
    },
}));

interface IStyleDetails {
    constant: IConstant
    constants: Constants
    id: string
    project: string
    style: StyleOptions
    value: any
}
export function StyleDetails({constant, constants, id, project, style, value}: IStyleDetails) {
    const classes = useStyles();
    const confirm = useContext(ConfirmContext);
    const {remove, set} = useContext(FirebaseContext);
    const handleDelete = (event: React.MouseEvent<HTMLElement>) =>
    {
        const constant = event.currentTarget.dataset.constant;
        const value = event.currentTarget.dataset.value;

        if (constant && value)
        {
            confirm(<Typography>Delete constant style?</Typography>).then(() =>
                remove(`constants/${project}/${constant}/style/${value}`)
            ).catch(console.error);
        }
    }
    const handleUpdateDate: MouseEventHandler<HTMLElement> = ({currentTarget}) => {
        if (currentTarget.dataset.constant) {
            const name = currentTarget.dataset.constant;
            const constant = constants[name];
            const value = currentTarget.dataset.value;
            const replace = Object.keys(constant.style || {}).pop();

            if (constant && value && replace) {
                const date = Date.now();
                const style = constant.style![replace];

                set(`constants/${project}/${name}/style/${date}`, style).then(() =>
                    remove(`constants/${project}/${name}/style/${replace}`)
                ).catch(console.error);
            }
        }
    }
    const setStyle = useCallback((constant: string, value: string, styleOptions: StyleOptions) =>
    {
        return set(`constants/${project}/${constant}/style/${value}`, styleOptions);
    }, [set, project])

    return (
        <Box className={classes.form}>
            <FormattingStyleOptions formatStyle={style} setFormatStyle={(style) => setStyle(id, value, style)} />
            <Box display="flex" justifyContent="right" marginLeft={1} marginRight={1}>
                {constant.type === "date" &&
                    <Button data-constant={id} data-value={value} onClick={handleUpdateDate}
                            sx={{marginRight: 1}} variant="contained">
                        Update
                    </Button>
                }
                <Button data-constant={id} data-value={value} onClick={handleDelete} variant="contained">
                    Delete
                </Button>
            </Box>
        </Box>
    );
}